import { FC } from 'react';
import { Outlet } from 'react-router';
import { Box, HStack } from '@chakra-ui/react';

import { SideNav } from '../SideNav/SideNav';
import { Loader } from '../Loader';

const SIDE_NAV_WIDTH = '210px';

export const Layout: FC = () => (
  <HStack h="100vh" align="start" spacing={SIDE_NAV_WIDTH}>
    <SideNav width={SIDE_NAV_WIDTH} />
    <Box height="100%" flex="1">
      <Outlet />
    </Box>
    <Loader />
  </HStack>
);
